/* ------------------------------------------------------------------ */
/* Domain data                                                         */
/* ------------------------------------------------------------------ */

export type Currency = 'USD' | 'EUR'

export type Plan = {
  id: string
  name: string
  note?: string
  priceUsd: number
  custom?: boolean
}

export type Service = {
  id: string
  name: string
  english: string
  glyph: string
  category: string
  tagline: string
  fromUsd: number
  popular?: boolean
  operations: string[]
  plans: Plan[]
  region?: boolean
}

export type Category = { id: string; name: string; glyph: string; count: number; slug: string }

export const categories: Category[] = [
  { id: 'ai', slug: 'ai', name: 'هوش مصنوعی', glyph: '✦', count: 12 },
  { id: 'dev', slug: 'development', name: 'برنامه‌نویسی و توسعه', glyph: '◉', count: 8 },
  { id: 'design', slug: 'design', name: 'طراحی و تولید محتوا', glyph: '▣', count: 7 },
  { id: 'biz', slug: 'business', name: 'بهره‌وری و کسب‌وکار', glyph: '⌘', count: 9 },
  { id: 'edu', slug: 'education', name: 'آموزش و دانشگاه', glyph: '◇', count: 5 },
  { id: 'game', slug: 'gaming', name: 'بازی و سرگرمی', glyph: '▦', count: 6 },
  { id: 'media', slug: 'media', name: 'موسیقی و فیلم', glyph: '♫', count: 4 },
  { id: 'gift', slug: 'gift-cards', name: 'گیفت‌کارت', glyph: '◫', count: 10 },
  { id: 'other', slug: 'other', name: 'سایر خدمات', glyph: '＋', count: 3 },
]

export const services: Service[] = [
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    english: 'OpenAI',
    glyph: '✦',
    category: 'ai',
    tagline: 'اشتراک و اعتبار API هوش مصنوعی OpenAI',
    fromUsd: 20,
    popular: true,
    operations: ['خرید اولیه', 'تمدید', 'ارتقا'],
    plans: [
      { id: 'plus', name: 'Plus', note: 'اشتراک ماهانه', priceUsd: 20 },
      { id: 'pro', name: 'Pro', note: 'حرفه‌ای', priceUsd: 200 },
      { id: 'team', name: 'Team', note: 'به‌ازای هر عضو', priceUsd: 30 },
    ],
  },
  {
    id: 'claude',
    name: 'Claude',
    english: 'Anthropic',
    glyph: '◈',
    category: 'ai',
    tagline: 'اشتراک Pro/Max و شارژ اعتبار API',
    fromUsd: 18,
    popular: true,
    operations: ['خرید اولیه', 'تمدید', 'شارژ', 'test', 'test again', 'متن طولانییییییییییییی'],
    plans: [
      { id: 'pro', name: 'Pro', note: 'اشتراک ماهانه', priceUsd: 18 },
      { id: 'max', name: 'Maxsfsdfdsf', note: 'حرفه‌ای', priceUsd: 100 },
      { id: 'api', name: 'API', note: 'مبلغ دلخواه', priceUsd: 0, custom: true },
      { id: 'api', name: 'API45345352', note: 'مبلغ دلخواه', priceUsd: 0, custom: true },
      { id: 'api', name: 'API453453dfgd52', note: 'مبلغ دلخواه', priceUsd: 0, custom: true },
    ],
  },
  {
    id: 'gemini',
    name: 'Gemini',
    english: 'Google',
    glyph: '◇',
    category: 'ai',
    tagline: 'اشتراک Google AI و Gemini Advanced',
    fromUsd: 20,
    popular: true,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [{ id: 'advanced', name: 'Advanced', note: 'ماهانه', priceUsd: 20 }],
  },
  {
    id: 'perplexity',
    name: 'Perplexity',
    english: 'Perplexity AI',
    glyph: '◐',
    category: 'ai',
    tagline: 'اشتراک Pro موتور پاسخ هوشمند',
    fromUsd: 20,
    popular: true,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [{ id: 'pro', name: 'Pro', note: 'ماهانه', priceUsd: 20 }],
  },
  {
    id: 'midjourney',
    name: 'Midjourney',
    english: 'Midjourney',
    glyph: '❖',
    category: 'design',
    tagline: 'اشتراک تولید تصویر هوش مصنوعی',
    fromUsd: 10,
    popular: true,
    operations: ['خرید اولیه', 'تمدید', 'ارتقا'],
    plans: [
      { id: 'basic', name: 'Basic', priceUsd: 10 },
      { id: 'standard', name: 'Standard', priceUsd: 30 },
      { id: 'pro', name: 'Pro', priceUsd: 60 },
    ],
  },
  {
    id: 'copilot',
    name: 'GitHub Copilot',
    english: 'GitHub',
    glyph: '◉',
    category: 'dev',
    tagline: 'دستیار کدنویسی هوشمند',
    fromUsd: 10,
    popular: true,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [
      { id: 'individual', name: 'Copilot Individual', priceUsd: 10 },
      { id: 'business', name: 'Copilot Business', priceUsd: 19 },
    ],
  },
  {
    id: 'openai-codex',
    name: 'OpenAI Codex',
    english: 'OpenAI',
    glyph: '✦',
    category: 'dev',
    tagline: 'اشتراک Codex توسعه‌دهنده',
    fromUsd: 20,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [{ id: 'codex', name: 'Codex Pro', note: 'ماهانه', priceUsd: 20 }],
  },
  {
    id: 'cursor',
    name: 'Cursor',
    english: 'Anysphere',
    glyph: '⌘',
    category: 'dev',
    tagline: 'ادیتور هوشمند کدنویسی',
    fromUsd: 20,
    popular: true,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [
      { id: 'pro', name: 'Pro', priceUsd: 20 },
      { id: 'business', name: 'Business', priceUsd: 40 },
    ],
  },
  {
    id: 'windsurf',
    name: 'Windsurf',
    english: 'Codeium',
    glyph: '◉',
    category: 'dev',
    tagline: 'IDE هوشمند با کدکس',
    fromUsd: 15,
    popular: true,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [
      { id: 'pro', name: 'Pro', priceUsd: 15 },
      { id: 'super', name: 'Pro Ultimate', note: 'نامحدود', priceUsd: 35 },
    ],
  },
  {
    id: 'canva',
    name: 'Canva',
    english: 'Canva',
    glyph: '▣',
    category: 'design',
    tagline: 'اشتراک طراحی گرافیک Pro',
    fromUsd: 13,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [{ id: 'pro', name: 'Pro', note: 'ماهانه', priceUsd: 13 }],
  },
  {
    id: 'figma',
    name: 'Figma',
    english: 'Figma',
    glyph: '▣',
    category: 'design',
    tagline: 'اشتراک طراحی رابط کاربری',
    fromUsd: 12,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [
      { id: 'professional', name: 'Professional', priceUsd: 12 },
      { id: 'org', name: 'Organization', priceUsd: 45 },
    ],
  },
  {
    id: 'notion',
    name: 'Notion',
    english: 'Notion',
    glyph: '⌘',
    category: 'biz',
    tagline: 'اشتراک فضای کاری تیمی',
    fromUsd: 10,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [{ id: 'plus', name: 'Plus', note: 'ماهانه', priceUsd: 10 }],
  },
  {
    id: 'google-one',
    name: 'Google One',
    english: 'Google',
    glyph: '◇',
    category: 'biz',
    tagline: 'فضای ذخیره‌سازی ابری',
    fromUsd: 2,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [
      { id: '100gb', name: '100GB', priceUsd: 2 },
      { id: '200gb', name: '200GB', priceUsd: 3 },
      { id: '2tb', name: '2TB', priceUsd: 10 },
    ],
  },
  {
    id: 'netflix',
    name: 'Netflix',
    english: 'Netflix',
    glyph: '♫',
    category: 'media',
    tagline: 'اشتراک تماشای فیلم و سریال',
    fromUsd: 7,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [
      { id: 'standard', name: 'Standard', priceUsd: 7 },
      { id: 'premium', name: 'Premium', priceUsd: 11 },
    ],
  },
  {
    id: 'spotify',
    name: 'Spotify',
    english: 'Spotify',
    glyph: '♫',
    category: 'media',
    tagline: 'اشتراک موسیقی Premium',
    fromUsd: 6,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [{ id: 'premium', name: 'Premium', note: 'فردی', priceUsd: 6 }],
  },
  {
    id: 'youtube',
    name: 'YouTube Premium',
    english: 'Google',
    glyph: '♫',
    category: 'media',
    tagline: 'تماشای بدون تبلیغ و YouTube Music',
    fromUsd: 14,
    operations: ['خرید اولیه', 'تمدید'],
    plans: [
      { id: 'individual', name: 'Individual', priceUsd: 14 },
      { id: 'family', name: 'Family', priceUsd: 23 },
    ],
  },
  {
    id: 'chatgpt-extra',
    name: 'API Credit',
    english: 'OpenAI',
    glyph: '✦',
    category: 'ai',
    tagline: 'شارژ اعتبار API OpenAI',
    fromUsd: 5,
    operations: ['شارژ'],
    plans: [{ id: 'custom', name: 'مبلغ دلخواه', note: 'از ۵ دلار', priceUsd: 0, custom: true }],
  },
  {
    id: 'claude-extra',
    name: 'API Credit',
    english: 'Anthropic',
    glyph: '◈',
    category: 'ai',
    tagline: 'شارژ اعتبار API Anthropic',
    fromUsd: 5,
    operations: ['شارژ'],
    plans: [{ id: 'custom', name: 'مبلغ دلخواه', note: 'از ۵ دلار', priceUsd: 0, custom: true }],
  },
  {
    id: 'openai-extra',
    name: 'ChatGPT Plus (1-Yr)',
    english: 'OpenAI',
    glyph: '✦',
    category: 'ai',
    tagline: 'یک سال اشتراک Plus با تخفیف',
    fromUsd: 180,
    operations: ['خرید اولیه'],
    plans: [{ id: 'yearly', name: 'Plus یکساله', priceUsd: 180 }],
  },
  {
    id: 'midjourney-extra',
    name: 'Midjourney (Yearly)',
    english: 'Midjourney',
    glyph: '❖',
    category: 'design',
    tagline: 'یک سال اشتراک با تخفیف ویژه',
    fromUsd: 96,
    operations: ['خرید اولیه'],
    plans: [
      { id: 'basic-year', name: 'Basic یکساله', priceUsd: 96 },
      { id: 'standard-year', name: 'Standard یکساله', priceUsd: 288 },
    ],
  },
]

export type GiftCard = {
  id: string
  name: string
  regions: string[]
  minUsd: number
  maxUsd: number
  fromUsd?: number
  popular?: boolean
}

export const giftCards: GiftCard[] = [
  { id: 'apple', name: 'Apple Gift Card', regions: ['US'], minUsd: 10, maxUsd: 200, popular: true },
  { id: 'googleplay', name: 'Google Play', regions: ['US', 'TR'], minUsd: 5, maxUsd: 100, popular: true },
  { id: 'steam', name: 'Steam Wallet', regions: ['US', 'TR'], minUsd: 5, maxUsd: 100, popular: true },
  { id: 'amazon', name: 'Amazon Gift Card', regions: ['US'], fromUsd: 10, minUsd: 10, maxUsd: 500 },
  { id: 'spotify-gc', name: 'Spotify Gift Card', regions: ['US'], fromUsd: 10, minUsd: 10, maxUsd: 100 },
  { id: 'netflix-gc', name: 'Netflix Gift Card', regions: ['US', 'TR'], fromUsd: 10, minUsd: 10, maxUsd: 100 },
  { id: 'xbox', name: 'Xbox Gift Card', regions: ['US'], fromUsd: 10, minUsd: 10, maxUsd: 100 },
  { id: 'psn', name: 'PlayStation Store', regions: ['US', 'TR'], fromUsd: 10, minUsd: 10, maxUsd: 100 },
  { id: 'nintendo', name: 'Nintendo eShop', regions: ['US'], fromUsd: 10, minUsd: 10, maxUsd: 100 },
  { id: 'itunes', name: 'iTunes Gift Card', regions: ['US'], fromUsd: 10, minUsd: 10, maxUsd: 200 },
]

export type OrderStatus = 'awaiting_payment' | 'paid' | 'reviewing' | 'action_required' | 'done' | 'failed'

export const statusMeta: Record<
  OrderStatus,
  { label: string; tone: 'warning' | 'success' | 'info' | 'danger' | 'neutral' }
> = {
  awaiting_payment: { label: 'در انتظار پرداخت', tone: 'warning' },
  paid: { label: 'پرداخت شده', tone: 'info' },
  reviewing: { label: 'در حال بررسی', tone: 'info' },
  action_required: { label: 'نیاز به اقدام شما', tone: 'danger' },
  done: { label: 'انجام شده', tone: 'success' },
  failed: { label: 'ناموفق', tone: 'danger' },
}

export type Order = {
  code: string
  service: string
  plan: string
  type: string
  glyph: string
  date: string
  status: OrderStatus
  totalRial: number
  timeline: { label: string; done: boolean; at?: string }[]
}

export const orders: Order[] = [
  {
    code: 'PJ-۸۴۲۳۹',
    service: 'ChatGPT',
    plan: 'Plus',
    type: 'خرید اولیه',
    glyph: '✦',
    date: '۱۴۰۵/۰۲/۱۵',
    status: 'action_required',
    totalRial: 1_900_000,
    timeline: [
      { label: 'ثبت سفارش', done: true, at: '۱۴:۳۲' },
      { label: 'پرداخت', done: true, at: '۱۴:۳۳' },
      { label: 'در حال اجرا', done: true, at: '۱۴:۴۰' },
      { label: 'نیازمند کد ورود', done: true, at: '۱۴:۴۵' },
      { label: 'انجام شده', done: false },
    ],
  },
  {
    code: 'PJ-۸۴۲۳۸',
    service: 'Claude',
    plan: 'Pro',
    type: 'تمدید',
    glyph: '◈',
    date: '۱۴۰۵/۰۲/۱۰',
    status: 'done',
    totalRial: 1_700_000,
    timeline: [
      { label: 'ثبت سفارش', done: true, at: '۱۰:۰۰' },
      { label: 'پرداخت', done: true, at: '۱۰:۰۱' },
      { label: 'در حال اجرا', done: true, at: '۱۰:۱۰' },
      { label: 'انجام شده', done: true, at: '۱۰:۴۵' },
    ],
  },
  {
    code: 'PJ-۸۴۲۳۷',
    service: 'Netflix',
    plan: 'Premium',
    type: 'خرید اولیه',
    glyph: '♫',
    date: '۱۴۰۵/۰۱/۲۸',
    status: 'paid',
    totalRial: 1_050_000,
    timeline: [
      { label: 'ثبت سفارش', done: true, at: '۰۹:۱۵' },
      { label: 'پرداخت', done: true, at: '۰۹:۱۶' },
      { label: 'در حال اجرا', done: false },
      { label: 'انجام شده', done: false },
    ],
  },
  {
    code: 'PJ-۸۴۲۳۶',
    service: 'Google One',
    plan: '200GB',
    type: 'تمدید',
    glyph: '◇',
    date: '۱۴۰۵/۰۱/۲۰',
    status: 'done',
    totalRial: 290_000,
    timeline: [
      { label: 'ثبت سفارش', done: true },
      { label: 'پرداخت', done: true },
      { label: 'انجام شده', done: true },
    ],
  },
  {
    code: 'PJ-۸۴۲۳۵',
    service: 'Midjourney',
    plan: 'Standard',
    type: 'ارتقا',
    glyph: '❖',
    date: '۱۴۰۵/۰۱/۱۵',
    status: 'done',
    totalRial: 2_800_000,
    timeline: [
      { label: 'ثبت سفارش', done: true },
      { label: 'پرداخت', done: true },
      { label: 'انجام شده', done: true },
    ],
  },
  {
    code: 'PJ-۸۴۲۳۴',
    service: 'Apple Gift Card',
    plan: 'US $50',
    type: 'خرید',
    glyph: '◫',
    date: '۱۴۰۴/۱۲/۲۸',
    status: 'done',
    totalRial: 4_600_000,
    timeline: [
      { label: 'ثبت سفارش', done: true },
      { label: 'پرداخت', done: true },
      { label: 'انجام شده', done: true },
    ],
  },
  {
    code: 'PJ-۸۴۲۳۳',
    service: 'ChatGPT',
    plan: 'Pro',
    type: 'ارتقا',
    glyph: '✦',
    date: '۱۴۰۴/۱۲/۱۰',
    status: 'failed',
    totalRial: 0,
    timeline: [
      { label: 'ثبت سفارش', done: true },
      { label: 'پرداخت', done: true },
      { label: 'ناموفق — عدم تأیید', done: true },
    ],
  },
]

export type Transaction = {
  id: string
  type: 'payment' | 'topup' | 'refund' | 'withdraw'
  amount: number
  date: string
  ref: string
  status: 'success' | 'pending' | 'failed'
}

export const transactions: Transaction[] = [
  { id: 't1', type: 'payment', amount: -1_900_000, date: '۱۴۰۵/۰۲/۱۵', ref: 'PJ-۸۴۲۳۹', status: 'success' },
  { id: 't2', type: 'topup', amount: 5_000_000, date: '۱۴۰۵/۰۲/۱۲', ref: 'F-۲۳۴۵۱', status: 'success' },
  { id: 't3', type: 'payment', amount: -1_700_000, date: '۱۴۰۵/۰۲/۱۰', ref: 'PJ-۸۴۲۳۸', status: 'success' },
  { id: 't4', type: 'payment', amount: -1_050_000, date: '۱۴۰۵/۰۱/۲۸', ref: 'PJ-۸۴۲۳۷', status: 'pending' },
  { id: 't5', type: 'payment', amount: -290_000, date: '۱۴۰۵/۰۱/۲۰', ref: 'PJ-۸۴۲۳۶', status: 'success' },
  { id: 't6', type: 'payment', amount: -2_800_000, date: '۱۴۰۵/۰۱/۱۵', ref: 'PJ-۸۴۲۳۵', status: 'success' },
  { id: 't7', type: 'payment', amount: -4_600_000, date: '۱۴۰۴/۱۲/۲۸', ref: 'PJ-۸۴۲۳۴', status: 'success' },
  { id: 't8', type: 'topup', amount: 3_000_000, date: '۱۴۰۴/۱۲/۲۰', ref: 'F-۲۳۴۵۰', status: 'success' },
  { id: 't9', type: 'refund', amount: 1_900_000, date: '۱۴۰۴/۱۲/۱۰', ref: 'PJ-۸۴۲۳۳', status: 'success' },
]

export type Notification = {
  id: string
  title: string
  body: string
  date: string
  tone: 'success' | 'warning' | 'info'
  unread: boolean
}

export const notifications: Notification[] = [
  {
    id: 'n1',
    title: 'سفارش انجام شد',
    body: 'سفارش ChatGPT Plus با موفقیت انجام شد.',
    date: 'امروز',
    tone: 'success',
    unread: true,
  },
  {
    id: 'n2',
    title: 'تمدید موفق',
    body: 'اشتراک Claude Pro با موفقیت تمدید شد.',
    date: 'دیروز',
    tone: 'success',
    unread: true,
  },
  {
    id: 'n3',
    title: 'افزایش موجودی موفق',
    body: 'مبلغ ۵٬۰۰۰٬۰۰۰ تومان به کیف پول شما اضافه شد.',
    date: '۲ روز پیش',
    tone: 'info',
    unread: false,
  },
  {
    id: 'n4',
    title: 'نیاز به کد ورود',
    body: 'سفارش ChatGPT نیاز به کد دومرحله‌ای دارد.',
    date: '۳ روز پیش',
    tone: 'warning',
    unread: false,
  },
  {
    id: 'n5',
    title: 'پرداخت ناموفق',
    body: 'پرداخت سفارش Midjourney ناموفق بود.',
    date: 'یک هفته پیش',
    tone: 'warning',
    unread: false,
  },
]

export type Message = { id: string; from: 'user' | 'support'; body: string; at: string }
export const supportThread: Message[] = [
  { id: 'm1', from: 'user', body: 'سلام، سفارش Claude من نیاز به کد ورود دارد. چطور کد را ارسال کنم؟', at: '۱۰:۱۲' },
  {
    id: 'm2',
    from: 'support',
    body: 'سلام. کد دومرحله‌ای که به شماره شما پیامک می‌شود را از طریق دکمهٔ «ارسال کد» در صفحهٔ سفارش وارد کنید.',
    at: '۱۰:۱۵',
  },
  { id: 'm3', from: 'user', body: 'ممنون، ارسال کردم.', at: '۱۰:۱۸' },
  {
    id: 'm4',
    from: 'support',
    body: 'دریافت شد. سفارش شما در حال نهایی‌سازی است و تا کمتر از یک ساعت انجام می‌شود.',
    at: '۱۰:۲۰',
  },
]

export const faqs = [
  {
    q: 'سفارش در چه مدتی انجام می‌شود؟',
    a: 'زمان معمول بررسی و انجام سفارش حداکثر ۲۴ ساعت است. بسیاری از سفارش‌ها بسیار سریع‌تر انجام می‌شوند.',
  },
  {
    q: 'چرا مبلغ نهایی ممکن است تغییر کند؟',
    a: 'برخی هزینه‌ها مانند VAT، Service Fee یا مالیات منطقه‌ای ممکن است هنگام ثبت سفارش کامل مشخص نباشند و در مرحلهٔ اجرا نهایی شوند.',
  },
  {
    q: 'اطلاعات ورود چگونه استفاده می‌شود؟',
    a: 'اطلاعات ورود فقط برای انجام همین سفارش در اختیار PayJib قرار می‌گیرد و پس از انجام سفارش قابل تغییر است.',
  },
  {
    q: 'اگر سرویس موردنظر در فهرست نباشد چه کاری انجام دهم؟',
    a: 'می‌توانید مشخصات پرداخت خود را از طریق «سفارش اختصاصی» ارسال کنید تا پس از بررسی، مبلغ و امکان انجام به شما اعلام شود.',
  },
  {
    q: 'گیفت‌کارت چگونه تحویل داده می‌شود؟',
    a: 'کد دیجیتال گیفت‌کارت از طریق ایمیل یا پیامک ارسال و در پنل کاربری نیز نمایش داده می‌شود.',
  },
  {
    q: 'آیا سفارش قابل لغو یا بازگشت است؟',
    a: 'سفارش پس از ثبت قابل لغو نیست و پرداخت‌های انجام‌شده مرجوعی نیستند. کدهای دیجیتال پس از صدور قابل تعویض نیستند.',
  },
  {
    q: 'در صورت نیاز به کد ورود چه اتفاقی می‌افتد؟',
    a: 'اگر هنگام اجرای سفارش کد ورود لازم باشد، وضعیت سفارش به «نیازمند اقدام شما» تغییر می‌کند و از شما درخواست ارسال کد می‌شود.',
  },
]

export interface RawCountry {
  id: string
  title: { fa: string; en?: string }
  flagUrl?: string
  iso: string
  callingCode: number
  availability?: {
    registration: boolean
    transaction: boolean
  }
}

export const countries: RawCountry[] = [
  {
    id: 'd99c188e-e103-4426-bdc1-60e3f328c3e1',
    title: { fa: 'ایران', en: 'Iran' },
    callingCode: 98,
    iso: 'IR',
    availability: { registration: true, transaction: true },
  },
  {
    id: 'd1fded66-bf31-4ce5-a70a-cdf3e26eb549',
    title: { fa: 'افغانستان', en: 'Afghanistan' },
    callingCode: 93,
    iso: 'AF',
    availability: { registration: true, transaction: true },
  },
  {
    id: '2c7a89d6-7dee-4a27-9128-2d0dfb056202',
    title: { fa: 'ترکیه', en: 'Turkey' },
    callingCode: 90,
    iso: 'TR',
    availability: { registration: true, transaction: true },
  },
  {
    id: '1efda87c-68ac-4317-bd9e-8f8cf7aca707',
    title: { fa: 'امارات متحده عربی', en: 'United Arab Emirates' },
    callingCode: 971,
    iso: 'AE',
    availability: { registration: true, transaction: true },
  },
]
